import { useState, useRef, useEffect } from "react";

//interfaces
import { ISelectItemList } from "@/interfaces/selectItemList";

//styling
import "../../../../../css/global/lists/selectItemList.scss";



const SelectItemList = ({items, showCheckbox = false, handleClick} : ISelectItemList) => {   

    const [focusedIndex, setFocusedIndex] = useState<number | null>(0); // Initialize to 0
    const listRef = useRef<HTMLUListElement>(null);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLLIElement>, index: number) => {
        switch (event.key) {
            case "ArrowDown":
                event.preventDefault();
                setFocusedIndex((prev) => (prev === null ? 0 : Math.min(prev + 1, items.length - 1)));
                break;
            case "ArrowUp":
                event.preventDefault();
                setFocusedIndex((prev) => (prev === null ? 0 : Math.max(prev - 1, 0)));
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                handleClick(index);
                break;
            case "Escape":
                setFocusedIndex(null);
            default:  
                break;
        }
      };
    
    const handleItemClick = (e: React.MouseEvent, index: number) => {
        e.preventDefault();
        handleClick(index);
    };

    useEffect(() => {
        if (focusedIndex !== null && listRef.current) {
            const focusedItem = listRef.current.children[focusedIndex] as HTMLLIElement;
            if (focusedItem) {
                focusedItem.scrollIntoView({ block: 'nearest' });
                const listItemElement = focusedItem.querySelector('.select-list-item');
                if (listItemElement) {
                    (listItemElement as any).focus(); // Focus the button itself
                }
            }
        }
    }, [focusedIndex]);
    
    return (
        <ul ref={listRef} className={`select-list ${items.length === 1 ? 'single-item' : ''}`} role="menu"> 
            {items.map((item, index) => (
                <li key={index} 
                    className={`select-list-item ${item.isSelected && 'is-selected'}`} 
                    onClick={item?.isDisabled !== true && ((e) => handleItemClick(e, index))}
                    onKeyDown={(event) => handleKeyDown(event, index)}
                    role="menuitem"
                    tabIndex={0}
                    aria-disabled={item?.isDisabled}
                >
                    <div className="list-content">
                        <span className="header">{item.header} {item?.tooltipIcon}</span>
                        <span className="content">{item.content}</span>
                    </div>

                    {showCheckbox && 
                        <div className="custom-checkbox">
                            <input type="checkbox" checked={item.isSelected} readOnly tabIndex={-1} aria-label={`Select ${item.header}`} disabled={item?.isDisabled}/>
                            <span className="custom-list-checkmark"></span>
                        </div>
                    }
                </li>
            ))}
        </ul>
    );
}

export default SelectItemList